import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
interface QA {
  q: string;
  a: string;
}
const faqs: QA[] = [{
  q: "¿Necesito experiencia administrando un negocio?",
  a: "No. El sistema está diseñado para técnicos que quieren organizar mejor su trabajo sin necesidad de conocimientos de administración o contabilidad."
}, {
  q: "¿Sirve para cualquier país?",
  a: "Sí. Las plantillas son editables y pueden adaptarse fácilmente a cualquier país de habla hispana. El cambio de moneda del pago es automático según tu ubicación."
}, {
  q: "¿Cómo recibiré el material?",
  a: "Inmediatamente después de completar tu compra recibirás un correo con el acceso para descargar todos los sistemas."
}, {
  q: "¿El pago es único?",
  a: "Sí. Pagas una sola vez y el acceso es tuyo para siempre."
}, {
  q: "¿Los archivos son editables?",
  a: "Sí. Encontrarás plantillas listas para personalizar y utilizar según las necesidades de tu negocio."
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-neutral-900 py-14" data-id="element-54" data-mp="uey5tqhviwiw">
      <div className="mx-auto max-w-lg px-4" data-id="element-55" data-mp="fiqe8544ystl">
        <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-56" data-mp="fm4g7c8w100i">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-57" data-mp="6r6i7qqvux2b">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-xl border border-white/10 bg-neutral-950" data-id="element-58" data-mp="bjhm14oqv305" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-59" data-mp="1rk7pp2fvux7">
                  <span className="font-display text-sm font-bold text-white" data-id="element-60" data-mp="1ugun1xgd8dr3">
                    {f.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-amber-400 transition-transform ${isOpen ? "rotate-180" : ""}`} data-id="element-61" data-mp="1ppunekfv3hkw" />
                </button>
                <AnimatePresence initial={false} data-id="element-62" data-mp="1ftrmfhwqxozj">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-63" data-mp="2df6wzlf3prnq">
                      <p className="px-4 pb-4 text-sm leading-relaxed text-white/70" data-id="element-64" data-mp="1zew82nxcqn57">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}